import { AfterViewInit, Component, ElementRef, Renderer } from '@angular/core';
import { JhiAlertService, JhiEventManager, JhiLanguageService } from 'ng-jhipster';

import { User } from '../../../models';
import { AccountService } from '../../../services';
import { AlertUtils } from '../../../shared';

@Component({
    selector: 'qms-register',
    templateUrl: './register.component.html'
})
export class RegisterComponent implements AfterViewInit {
    public passwordMinLength = User.PASSWORD_MIN_LENGTH;
    public passwordMaxLength = User.PASSWORD_MAX_LENGTH;
    public emailMinLength = User.EMAIL_MIN_LENGTH;
    public emailMaxLength = User.EMAIL_MAX_LENGTH;
    public loginMinLength = User.LOGIN_MIN_LENGTH;
    public loginMaxLength = User.LOGIN_MAX_LENGTH;
    public loginPattern = User.LOGIN_PATTERN;

    public newAccount: User;
    public success: boolean;
    public confirmPassword: string;

    constructor(private languageService: JhiLanguageService,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private elementRef: ElementRef,
                private renderer: Renderer,
                private accountService: AccountService) {
        this.success = false;
        this.newAccount = new User();
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#login'), 'focus', []);
    }

    public register() {

        if (this.newAccount.password !== this.confirmPassword) {
            AlertUtils.notifyError(this.eventManager, this.alertService, 'global.messages.error.dontmatch');
            return;
        }

        this.languageService.getCurrent().then((key) => {
            this.newAccount.langKey = key;
            this.accountService.register(this.newAccount).subscribe(() => {
                this.success = true;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/register/register.component.ts